const townshipProvince = [
    {
        province: "La Habana",
        township: [
            "Cerro",
            "Diez de Octubre",
            "Habana Vieja",
            "Centro Habana",
            "Plaza de la Revolución",
            "Playa",
            "Marianao",
            "La Lisa",
            "Boyeros",
            "Cotorro",
            "Arroyo Naranjo",
            "Guanabacoa",
            "Habana del Este",
            "Regla",
            "San Miguel del Padrón"
        ]
    },
    {
        province: "Pinar del Río",
        township: [
            "Consolación del Sur",
            "Guane",
            "La Palma",
            "Los Palacios",
            "Mantua",
            "Minas de Matahambre",
            "Pinar del Río",
            "San Juan y Martínez",
            "San Luis",
            "Sandino",
            "Viñales"]
    },
    {
        province: "Artemisa",
        township: ["Alquízar",
            "Artemisa",
            "Bahía Honda",
            "Bauta",
            "Caimito",
            "Candelaria",
            "Guanajay",
            "Güira de Melena",
            "Mariel",
            "San Antonio de los Baños",
            "San Cristóbal"]
    },
    {
        province: "Mayabeque",
        township: [
            "Batabanó",
            "Bejucal",
            "Güines",
            "Jaruco",
            "Madruga",
            "Melena del Sur",
            "Nueva Paz",
            "Quivicán",
            "San José de las Lajas",
            "San Nicolás",
            "Santa Cruz del Norte"
        ]
    },
    {
        province: "Matanzas",
        township: [
            "Calimete",
            "Cárdenas",
            "Ciénaga de Zapata",
            "Colón",
            "Jagüey Grande",
            "Jovellanos",
            "Limonar",
            "Los Arabos",
            "Martí",
            "Matanzas",
            "Pedro Betancourt",
            "Perico",
            "Unión de Reyes"
        ]
    },
    {
        province: "Cienfuegos",
        township: ["Abreus",
            "Aguada de Pasajeros",
            "Cienfuegos",
            "Cruces",
            "Cumanayagua",
            "Lajas",
            "Palmira",
            "Rodas"]
    },
    {
        province: "Villa Clara",
        township: ["Caibarién",
            "Camajuaní",
            "Cifuentes",
            "Corralillo",
            "Encrucijada",
            "Manicaragua",
            "Placetas",
            "Quemado de Güines",
            "Ranchuelo",
            "San Juan de los Remedios",
            "Sagua la Grande",
            "Santa Clara",
            "Santo Domingo"]
    },
    {
        province: "Ciego de Ávila",
        township: [
            "Baraguá",
"Bolivia",
"Chambas",
"Ciego de Ávila",
"Ciro Redondo",
"Florencia",
"Majagua",
"Morón",
"Primero de Enero",
"Venezuela"
        ]
    },
    {
        province: "Camagüey",
        township: ["Camagüey",
            "Carlos M. de Céspedes",
            "Esmeralda",
            "Florida",
            "Guáimaro",
            "Jimaguayú",
            "Minas",
            "Najasa",
            "Nuevitas",
            "Santa Cruz del Sur",
            "Sibanicú",
            "Sierra de Cubitas",
            "Vertientes"]
    },
    {
        province: "Las Tunas",
        township: ["Amancio",
            "Colombia",
            "Jesús Menéndez",
            "Jobabo",
            "Las Tunas",
            "Majibacoa",
            "Manatí",
            "Puerto Padre"]
    },
    {
        province: "Holguín",
        township: ["Antilla",
            "Báguanos",
            "Banes",
            "Cacocum",
            "Calixto García",
            "Cueto",
            "Frank País",
            "Gibara",
            "Holguín",
            "Mayarí",
            "Moa",
            "Rafael Freyre",
            "Sagua de Tánamo",
            "Urbano Noris"]
    },
    {
        province: "Granma",
        township: ["Bartolomé Masó",
            "Bayamo",
            "Buey Arriba",
            "Campechuela",
            "Cauto Cristo",
            "Guisa",
            "Jiguaní",
            "Manzanillo",
            "Media Luna",
            "Niquero",
            "Pilón",
            "Río Cauto",
            "Yara"]
    },
    {
        province: "Santiago de Cuba",
        township: [
            "Contramaestre",
"Guamá",
"Mella",
"Palma Soriano",
"San Luis",
"Santiago de Cuba",
"Segundo Frente",
"Songo-La Maya",
"Tercer Frente"
        ]
    },
    {
        province: "Guantánamo",
        township: [
            "Baracoa",
"Caimanera",
"El Salvador",
"Guantánamo",
"Imías",
"Maisí",
"Manuel Tames",
"Niceto Pérez",
"San Antonio del Sur",
"Yateras"
        ]
    },
    {
        province: "Isla de la Juventud",
        township: ["Nueva Gerona"]
    },
]
export default townshipProvince;